import React, { useContext, useEffect, useState } from "react";

import Form from "../../../components/form/form";
import Input from "../../../components/input/input";
import {
  Route,
  Switch,
  useHistory,
} from "react-router-dom/cjs/react-router-dom";
import { BackendContext, backendStatus } from "../../../backend/backend";
import { MainHeaderContext } from "../../../components/main-header/main-header-state";
import CnpjUtils from "../cpnj-utils";
import IspDataCard from "./isp-data-card";
import Tabs from "../../../components/tabs/tabs";
import { BatchAction } from "./batch-action-modal";
import "./batch-actions-page.css";
import Loading from "../../../components/loading/loading";

export default function BatchActionsPage() {
  const [cnpj, setCNPJ] = useState("");
  const [isp, setISP] = useState(null);
  const [profile, setProfile] = useState({
    name: "-",
    id: "-",
  });
  const [updates, setUpdates] = useState({});
  const [firmwares, setFirmwares] = useState([]);
  const [versionModels, setVersionModels] = useState({ total: 0, models: [] });
  const [loading, setLoading] = useState(false);
  const [searched, setSearched] = useState(false);
  const header = useContext(MainHeaderContext);
  const backend = useContext(BackendContext);
  const history = useHistory();
  const colorPalette = ["#62BE6E", "#799866", "#BD7F75"];

  useEffect(() => {
    header.title.set("Ações em lote");
    const getFirmwares = async () => {
      let result = await backend.retrieveFresh("/firmwares");
      if (result.status === backendStatus.SUCCESS) {
        setFirmwares(result.content);
      }
    };

    getFirmwares();
  }, []);

  const searchISP = async () => {
    setSearched(true);
    setLoading(true);
    let ispResult = await backend.retrieveFresh(
      `isps/${CnpjUtils.removeMask(cnpj)}`
    );
    if (ispResult.status === backendStatus.SUCCESS) {
      setISP(ispResult.content);
      let profileResult = await backend.retrieveFresh(
        `isps/${ispResult.content.ispid}/default-profile`
      );
      fetchStats(ispResult.content.ispid);
      if (profileResult.status === backendStatus.SUCCESS) {
        setProfile({
          name: profileResult.content?.name,
          id: profileResult.content?._id,
        });
      }
    } else {
      setISP(null);
    }
    setLoading(false);
  };

  const fetchStats = async (scope) => {
    let briefResult = await backend.retrieveFresh(`devices/batch-brief/${scope}`);
    if (briefResult.status === backendStatus.SUCCESS) {
      let models = briefResult.content.models;

      for (let model of models) {
        model.versions.sort(function (a, b) {
          return a.count > b.count ? -1 : 1;
        });
      }

      models = models.map((obj) => ({
        ...obj,
        versions: obj.versions.map((v, i) => ({
          ...v,
          color: getVersionChartColor(i),
        })),
      }));

      setVersionModels({ total: briefResult.content.total, models: models });
    }

    let updatesResult = await backend.retrieveFresh(`updates/batch-update/${scope}`);
    if (updatesResult.status === backendStatus.SUCCESS) {
      setUpdates(updatesResult.content);
    }
  };

  const getVersionChartColor = (index) => {
    if (index >= colorPalette.length) {
      return getRandomColor();
    }

    return colorPalette[index];
  };

  const getRandomColor = () => {
    return "#" + Math.floor(Math.random() * 16777215).toString(16);
  };

  return (
    <div className="batch-actions-page">
      <Form
        onSubmit={searchISP}
        id="users-search"
        submitText="Buscar"
        buttonId="search-button"
      >
        <Input
          id="search-input"
          value={cnpj}
          onChange={(e) => {
            if (!CnpjUtils.isValidValue(e)) return;

            setCNPJ(e.target.value);
          }}
          onBlur={() => setCNPJ(CnpjUtils.applyMask(cnpj))}
          onFocus={() => setCNPJ(CnpjUtils.removeMask(cnpj))}
          placeholder="CNPJ"
        ></Input>
      </Form>
      {isp !== null && !loading ? (
        <>
          <Tabs
            route={history.location.pathname}
            activateFn={(route) => history.push(route)}
            data={[
              {
                label: "Associação de dispositivos",
                route: "/batch-actions/associate",
              },
              {
                label: "Desassociação de dispositivos",
                route: "/batch-actions/disassociate",
              },
              {
                label: "Atualização de dispositivos",
                route: "/batch-actions/update",
              },
              {
                label: "Atualização de perfis",
                route: "/batch-actions/profile",
              },
            ]}
          ></Tabs>

          <div style={{ paddingTop: "20px" }}>
            <Switch>
              <Route path="/batch-actions/associate">
                <IspDataCard
                  isp={isp}
                  profile={profile}
                  batchAction={BatchAction.ASSOCIATE}
                  versionModels={versionModels}
                  updates={updates}
                  firmwares={firmwares}
                />
              </Route>
              <Route path="/batch-actions/disassociate">
                <IspDataCard
                  isp={isp}
                  profile={profile}
                  batchAction={BatchAction.DISASSOCIATE}
                  versionModels={versionModels}
                  updates={updates}
                  firmwares={firmwares}
                />
              </Route>
              <Route path="/batch-actions/update">
                <IspDataCard
                  isp={isp}
                  profile={profile}
                  batchAction={BatchAction.UPDATE}
                  versionModels={versionModels}
                  updates={updates}
                  firmwares={firmwares}
                />
              </Route>
              <Route path="/batch-actions/profile">
                <IspDataCard
                  isp={isp}
                  profile={profile}
                  batchAction={BatchAction.PROFILE_UPDATE}
                />
              </Route>
            </Switch>
          </div>
        </>
      ) : null}

      {loading && <Loading show={true}></Loading>}
      {isp === null && searched && (
        <div className="no-users-info">Nenhum provedor encontrado</div>
      )}
    </div>
  );
}
